import Menu from './customer_org.vue';

export default Menu;
